module.exports = __webpack_public_path__ + "img/icon-privacy.3d92eefa.svg";